module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/pc/en_shikoku-22e9069d0e40b529f7275a4a06e8d308.png";